<template>
  <v-card class="ma-2 pa-2" :color="child.id !== undefined ? '#dce9fb' : '#eaeaea'" outlined>
    <v-card-title class="d-flex justify-space-between align-center">
      <div class="d-flex align-center">
        <span>Banner Image</span>
        <div class="ml-2">
          <v-btn icon color="green" @click="moveUp()">
            <v-icon>mdi-arrow-up-bold-box</v-icon>
          </v-btn>
          <v-btn icon color="red" @click="moveDown()">
            <v-icon>mdi-arrow-down-bold-box</v-icon>
          </v-btn>
        </div>
      </div>
      <v-card-subtitle v-if="child.id">
        <v-switch
          v-model="child.is_active"
          :label="`isActive: ${child.is_active ? 'Yes' : 'No'}`"
          @change="onSwitchChange"
        />
      </v-card-subtitle>
    </v-card-title>
    <v-card-subtitle>
      <div>ID: {{ child.id }}</div>
      <div>Type: {{ child.type }}</div>
      <div>Sort Order: {{ child.sort_order }}</div>
    </v-card-subtitle>
    <v-card-text>
      <div class="d-flex flex-wrap">
        <v-flex xs8>
          <img :src="selectImageBase64 || child.image_url" class="mb-6" style="width: 100%" />
        </v-flex>
        <v-flex xs4 class="pl-4">
          <v-btn fab dark small color="cyan" elevation="1" @click="openImagePicker">
            <v-icon dark>edit</v-icon>
          </v-btn>
          <div class="mt-2">PNG, JPG no larger than 1MB</div>
        </v-flex>
        <v-flex xs12>
          <v-text-field label="CTA URL" v-model="child.cta_url" dense></v-text-field>
        </v-flex>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn v-if="child.id >= 0" color="primary" @click="save">Save</v-btn>
      <v-btn v-if="child.id >= 0" text color="error" @click="remove">Remove</v-btn>
      <v-btn v-if="child.id === undefined" color="primary" @click="save">Add</v-btn>
    </v-card-actions>
    <input type="file" ref="imageInput" style="display: none" accept="image/*" @change="onSelectFile" />
  </v-card>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import homefeedService from '../../../services/homefeed';
import { srcToBase64 } from '../../../utils/stringUtil';
export default Vue.extend({
  props: {
    child: {
      type: Object,
      required: true,
    },
    onChildChange: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectImageFileName: null,
      selectImageBase64: null,
    };
  },
  methods: {
    openImagePicker() {
      this.$refs.imageInput.click();
    },
    onSelectFile(e) {
      const files = e.target.files;
      const file = files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const base64String = event.target.result;
          this.selectImageFileName = file.name;
          this.selectImageBase64 = base64String;
        };
        reader.onerror = (error) => {
          console.error('Error reading file:', error);
        };
        reader.readAsDataURL(file);
      } else {
        console.error('No file selected');
      }
    },
    async save() {
      const requestBody = {
        cta_url: this.child.cta_url,
      };

      if (this.selectImageBase64) {
        requestBody.image_url = {
          image_base64: srcToBase64(this.selectImageBase64),
          image_filename: this.selectImageFileName,
        };
      }

      if (this.child.id === undefined) {
        await homefeedService.addChild(this.child.section_id, { type: this.child.type, ...requestBody });
        this.child.cta_url = '';
        this.selectImageFileName = null;
        this.selectImageBase64 = null;
        this.$refs.imageInput.value = null;
        this.onChildChange();
        console.log('Successfully added child ID:', this.child.id);
      } else {
        await homefeedService.updateChild(this.child.section_id, this.child.id, requestBody);
        console.log('Successfully updated child ID:', this.child.id);
      }
    },
    async remove() {
      if (this.child.id !== undefined) {
        this.$root
          .$confirm('Remove section', `Are you sure to remove this section?`, { color: 'error' })
          .then(async (confirm) => {
            if (confirm) {
              await homefeedService.deleteChild(this.child.section_id, this.child.id);
              this.onChildChange();
              console.log('Successfully deleted child ID:', this.child.id);
            }
          });
      }
    },
    async moveUp() {
      this.$root
        .$confirm('Move child up', `This change will take effect on app immediately.`, { color: 'primary' })
        .then(async (confirm) => {
          if (confirm) {
            await homefeedService.moveChild(this.child.section_id, this.child.id, -1);
            this.onChildChange();
          }
        });
    },
    async moveDown() {
      this.$root
        .$confirm('Move child down', `This change will take effect on app immediately.`, { color: 'primary' })
        .then(async (confirm) => {
          if (confirm) {
            await homefeedService.moveChild(this.child.section_id, this.child.id, 1);
            this.onChildChange();
          }
        });
    },
    async onSwitchChange() {
      if (this.child.id !== undefined) {
        await homefeedService.updateChild(this.child.section_id, this.child.id, {
          is_active: this.child.is_active,
        });
      }
    },
  },
});
</script>

<style scoped></style>
